import { render } from "./BaseMovies.vue?vue&type=template&id=2cc359e0&scoped=true"
import script from "./BaseMovies.vue?vue&type=script&lang=js"
export * from "./BaseMovies.vue?vue&type=script&lang=js"

import "./BaseMovies.vue?vue&type=style&index=0&id=2cc359e0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc359e0"]])

export default __exports__